import { SET_COMMISSION_INFO, CHANGE_USER_STATUS } from '../mutation-types'
import Vue from 'vue'

const state = {
  commissionInfo: {
    total: 0,
    withdraw: 0,
    balance: 0,
    inviteCode: '',
    inviteNum: 0
  },
  commissionApplyStatus: ''
}

const mutations = {
  [SET_COMMISSION_INFO] (state, data) {
    state.commissionInfo = data
  },
  setCommissionApplyStatus(state, status) {
    state.commissionApplyStatus = status
  },
  resetCommissionApplyStatus(state) {
    state.commissionApplyStatus = ''
  }
}

const actions = {
  getCommissionInfo ({commit}) {
    return new Promise(function (resolve) {
      Vue.http.get('api/commission-user-info', {
        headers: {
          'Cache-Control': window.sessionStorage.getItem('needUseNoCache') ? 'no-cache' : 'private'
        }
      }).then((response) => {
        if (response.data.code === 0) {
          resolve(response)
          commit(SET_COMMISSION_INFO, response.body.data)
        }
      })
    })
  },
  getCommissionApplyStatus({commit}) {
    if (!window.localStorage.getItem('token')) return
    return new Promise(function (resolve) {
      Vue.http.get('api/commission-status/apply').then((response) => {
        resolve(response)
        if (response.data.code === 0) {
          commit('setCommissionApplyStatus', response.data.data.status)
        }
      })
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/commission.js